// extracted by mini-css-extract-plugin
export default {"bannerContainer":"styles_bannerContainer__TBRo9","bannerImage":"styles_bannerImage__grnfo"};